<div
  class="relative w-full overflow-hidden  text-black py-16 md:py-24"
  [appScrollSection]="data?.anker"
>
  <!-- optional: sehr dezenter Background (kannst du mit Asset ersetzen) -->
  <div class="absolute inset-0 -z-10 opacity-30"></div>

  <div class="relative max-w-6xl mx-auto px-6">
    @switch (data?.type) {
      @case ("Type2") {
        <div
          class="type2 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center"
        >
          <!-- Bild links -->
          <div class="flex justify-center md:justify-start">
            <img
              [src]="data?.image?.fields?.file?.url"
              class="w-full max-w-[520px] md:max-w-none object-cover"
              alt=""
            />
          </div>

          <!-- Text rechts -->
          <div class="text-center md:text-center">
            <!-- Eyebrow -->
            <div class="font-primary italic uppercase text-2xl">
              {{ data?.title }}
            </div>

            <!-- Haupttext -->
            @if (data?.text) {
              <div
                class="mt-6 font-primary text-black text-lg sm:text-xl md:text-2xl leading-relaxed whitespace-pre-line"
                [innerHTML]="documentToHtmlString(data?.text)"
              ></div>
            }

            <!-- Zusatztext (optional: description, falls du es brauchst) -->
            @if (data?.description) {
              <div
                class="mt-6 font-primary text-black text-lg sm:text-xl md:text-2xl leading-relaxed"
                [innerHTML]="documentToHtmlString(data?.description)"
              ></div>
            }

            <!-- Button (zentriert, Type2 Look) -->
            <div class="mt-10 flex justify-center">
              @if (data?.button?.fields) {
                <jnguyen-button [button]="data.button.fields"></jnguyen-button>
              }
            </div>
          </div>
        </div>
      }
      @default {
        <!-- Hintergrundbild -->
        <div class="absolute inset-0 -z-10">
          @if (data?.background?.fields?.file?.url) {
            <img
              class="w-full h-full object-cover opacity-40 blur-sm"
              [src]="getImageUrl(data?.background?.fields?.file?.url)"
              alt=""
            />
          }
        </div>

        <!-- Oberer Textblock -->
        @if (data?.text) {
          <div
            class="text-center text-base sm:text-xl md:text-3xl leading-relaxed font-glacial text-black whitespace-pre-line"
            [innerHTML]="documentToHtmlString(data?.text)"
          ></div>
        }

        <div
          class="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start"
        >
          <div class="flex flex-col items-center md:items-start justify-center md:justify-start">
            <div class="z-10 text-center md:hidden">
              <p class="eyebrow uppercase">
                {{ data?.title }}
              </p>
            </div>
            <img
              [src]="data.image.fields.file.url"
              class="w-[280px] sm:w-[340px] md:w-[380px] object-cover rounded-md shadow-xl mt-10 md:mt-0"
              alt=""
            />
          </div>

          <div class="text-center md:text-left">
            <p class="eyebrow uppercase hidden md:block">
              {{ data?.title }}
            </p>

            <h2
              class="mt-4 text-3xl font-primary text-white font-bold tracking-wide"
            >
              {{ data?.subtitle }}
            </h2>

            @if (data?.description) {
              <div
                class="description mt-4 text-4xl font-primary leading-relaxed text-white"
                [innerHTML]="documentToHtmlString(data?.description)"
              ></div>
            }
            <div class="flex justify-center md:justify-start">
              <div class="mt-8 w-[250px]">
                @if (data?.button?.fields) {
                  <jnguyen-button
                    [button]="data?.button.fields"
                  ></jnguyen-button>
                }
              </div>
            </div>
          </div>
        </div>

        @if (data?.quote) {
          <div
            class="quote mt-16 md:mt-20 text-center text-3xl font-primary uppercase"
            [innerHTML]="documentToHtmlString(data?.quote)"
          ></div>
        }
      }
    }
  </div>
</div>
